export const SELECT_CLIENT_MODAL = {
  CLIENT_MODAL_HEADER: { key: "CLIENT_MODAL_HEADER", value: 'Choose client and confirm to release this design' },
  CLIENT_MODAL_DESC: { key: "CLIENT_MODAL_DESC", value: '(Releases the design to all the clients by default)' },
  CLIENT_LABEL: { key: "CLIENT_LABEL", value: 'CLIENT LIST' },
  CANCEL_BUTTON: { key: "CANCEL_BUTTON", value: 'Cancel' },
  CONFIRM_BUTTON: { key: "CONFIRM_BUTTON", value: 'Confirm' },
};

